module.exports = __webpack_public_path__ + "img/star.2f94b0fc.svg";